export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10220.b0ba4112.jpg";